import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { NgxSpinnerModule } from 'ngx-spinner';

import {
  TabsModule,
  FilterModule,
  PaginationModule,
  SettingsModule,
  ToolbarModule,
  TableModule,
  AutocompleteModule,
} from 'beyond-util';
import { ZeljenePozicijeComponent } from './zeljene-pozicije.component';

@NgModule({
  declarations: [ZeljenePozicijeComponent],
  entryComponents: [ZeljenePozicijeComponent],
  exports: [ZeljenePozicijeComponent],
  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    TabsModule,
    FilterModule,
    PaginationModule,
    SettingsModule,
    ToolbarModule,
    TableModule,
    AutocompleteModule,
    NgxSpinnerModule,
  ],
})
export class ZeljenePozicijeModule {}



// WEBPACK FOOTER //
// ./src/app/pages/zeljene-pozicije/zeljene-pozicije.module.ts